import React from 'react';
import { useSelector } from 'react-redux';

import { requestParamsSelector } from '@alumni_v2/selectors/reviews';
import { isUserLoggedIn, showReviewPageRevamp } from '@alumni_v2/utils/helpers';
import AlumniWrapperV2 from '../AlumniWrapperV2';

import { useMediaQuery } from '@common/hooks';
import BreadcrumbContainer from '@alumni_v2/ui/BreadcrumbContainer';
import styles from './AlumniWrapper.module.scss';

const AlumniWrapper = ({
  Filter,
  SearchBar,
  Banner,
  FilterTags,
  ShareProfile,
  FilterRecommendationButton,
  children,
}) => {
  const { quickFilters, showPersonalisationFilter } = window.__INITIAL_STATE__;
  const { tablet } = useMediaQuery();

  const isObjectNotEmpty = (obj) => obj && Object.keys(obj).length > 0;

  const requestParams = useSelector(requestParamsSelector) || {};
  const isShareable = useSelector((state) => state.reviews.isShareable);
  const isFilterApplied = requestParams?.quickFilters?.length > 0
  || isObjectNotEmpty(requestParams?.advancedFilters)
  || false;

  if (showReviewPageRevamp()) {
    return (
      <AlumniWrapperV2>
        {children}
      </AlumniWrapperV2>
    );
  }


  return (
    <>
      {tablet && (
        <div className={styles.bannerContainer}>
          <Banner />
        </div>
      )}
      <div className={styles.container}>
        {tablet ? (
          <div>
            <div className={styles.filtersContainer}>
              <div className={styles.searchFilter}>
                <SearchBar />
                <Filter />
              </div>
              {showPersonalisationFilter && <FilterRecommendationButton />}
              <FilterTags quickFilters={quickFilters} />
            </div>
            {isFilterApplied && isUserLoggedIn() && isShareable && (
              <div className={styles.shareProfileWrapper}>
                <ShareProfile />
              </div>
            )}
            <div className={styles.reviewsContainer}>{children}</div>
          </div>
        ) : (
          <>
            <BreadcrumbContainer />
            <div>
              <h1 className={styles.mainHeading}>Scaler Academy Reviews</h1>
              <p className={styles.mainDesc}>
                At Scaler, learners transform their careers, mastering coding
                and securing dream jobs. Discover genuine insights through
                honest reviews and testimonials.
              </p>
            </div>
            <div className={styles.mainContainer}>
              <div className={styles.filtersWrapper}>
                <div className={styles.filtersContainer}>
                  <Filter />
                </div>
              </div>
              <div className={styles.rightContainer}>
                <div className={styles.searchBar}>
                  <div className={styles.searchBarComponent}>
                    <SearchBar />
                  </div>
                  {showPersonalisationFilter && <FilterRecommendationButton />}
                </div>
                <div className={styles.reviewsContainer}>
                  <FilterTags quickFilters={quickFilters} showShareProfile />
                  <Banner />
                  {children}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default AlumniWrapper;
